import { useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { CheckCircleOutlined, ExperimentFilled, LogoutOutlined } from '../../icons';
import { ApiError } from '../../lib/http';
import { kioskHeartbeat, kioskLogout } from '../../services/auth';
import { clearSession, getUser } from '../../stores/session';

const FOOTER = '成都市第二十中学校 · 四川省成都市金牛区育英路6号 · 蜀ICP备15006431号-2 · 厚德明理，励志笃行';

export function KioskShell() {
  const user = getUser();
  const nav = useNavigate();

  useEffect(() => {
    const t = window.setInterval(async () => {
      try {
        await kioskHeartbeat();
      } catch (e) {
        if (e instanceof ApiError) {
          clearSession();
          nav('/kiosk/login', { replace: true });
        }
      }
    }, 60_000);
    return () => window.clearInterval(t);
  }, [nav]);

  async function logout() {
    try {
      await kioskLogout();
    } catch {
      /* still leave */
    }
    clearSession();
    nav('/kiosk/login', { replace: true });
  }

  return (
    <div className="kiosk-shell" data-density="kiosk">
      <header className="kiosk-header">
        <div>
          <div>成都市第二十中学校</div>
          <strong>大同科创共享中心预约平台</strong>
        </div>
        <div>当前学号 {user?.principal}</div>
      </header>
      <main className="kiosk-main">
        <Outlet />
      </main>
      <nav className="kiosk-nav">
        <NavLink to="/kiosk/courses" className={({ isActive }) => (isActive ? 'active' : '')}>
          <ExperimentFilled style={{ fontSize: 40 }} />
          开放实验
        </NavLink>
        <NavLink to="/kiosk/enrollments" className={({ isActive }) => (isActive ? 'active' : '')}>
          <CheckCircleOutlined style={{ fontSize: 40 }} />
          我的报名
        </NavLink>
        <span />
        <button type="button" className="kiosk-primary" onClick={() => void logout()}>
          <LogoutOutlined style={{ fontSize: 40 }} />
          退出
        </button>
      </nav>
      <div className="app-footer">{FOOTER}</div>
    </div>
  );
}
